import { InputAdornment } from "@material-ui/core";
import { Switch } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import IconButton from "@material-ui/core/IconButton";
import { makeStyles } from "@material-ui/core/styles";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableFooter from "@material-ui/core/TableFooter";
import TableRow from "@material-ui/core/TableRow";
import TextField from "@material-ui/core/TextField";
import { SearchOutlined } from "@material-ui/icons";
import DeleteIcon from "@material-ui/icons/Delete";
// import { DiscountValueTypeEnum } from "@saleor/types/globalTypes";
import CardTitle from "@saleor/components/CardTitle";
import Checkbox from "@saleor/components/Checkbox";
import ResponsiveTable from "@saleor/components/ResponsiveTable";
import Skeleton from "@saleor/components/Skeleton";
import TableHead from "@saleor/components/TableHead";
import TablePagination from "@saleor/components/TablePagination";
import { VoucherProductDetails_voucher_products_edges } from "@saleor/discounts/types/VoucherProductDetails";
import {
  VoucherVariantDetails_voucher_productVariants,
  VoucherVariantDetails_voucher_productVariants_edges
} from "@saleor/discounts/types/VoucherVariantDetails";
import { ProductListProps } from "@saleor/discounts/views/VoucherDetails/utils";
import { FormChange } from "@saleor/hooks/useForm";
import useSearchQuery from "@saleor/hooks/useSearchQuery";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import { maybe, renderCollection } from "../../../misc";
import { ListActions, ListProps } from "../../../types";
import { VoucherDetails_voucher } from "../../types/VoucherDetails";
import { VoucherDetailsPageFormData } from "../VoucherDetailsPage";
export interface SaleProductsProps
  extends ListProps,
    ProductListProps,
    ListActions {
  data: VoucherDetailsPageFormData;
  elligibleProducts: VoucherVariantDetails_voucher_productVariants;
  voucher: VoucherDetails_voucher;
  voucherProducts: VoucherProductDetails_voucher_products_edges[];
  voucherVariants: VoucherVariantDetails_voucher_productVariants_edges[];
  voucherStatus: boolean;
  onChange: FormChange;
  onFetch: (query: string) => void;
  onProductAssign: () => void;
  onProductUnassign: (id: string) => void;
}

const useStyles = makeStyles(
  theme => ({
    assignField: {
      margin: "5px"
    },
    buttonDisabled: {
      "& > span": {
        color: "#8198ff"
      }
    },
    buttonText: {
      "& .MuiButton-textPrimary span": {
        marginBottom: "50px"
      }
    },
    cardTitlebar: {
      alignItems: "center",
      display: "flex"
    },
    colActions: {
      "&:last-child": {
        paddingRight: 0
      },
      width: 76 + theme.spacing(0.5)
    },
    colEmpty: {
      width: "1px"
    },
    colName: {
      paddingLeft: 0,
      width: 230
    },
    colNameLabel: {
      // marginLeft: theme.spacing()
    },
    colPrice: {
      textAlign: "center",
      width: 100
    },
    colPublished: {
      width: 150
    },
    colSKU: {
      "@media (min-width: 769px)": {
        wordBreak: "break-all"
      },
      width: 150
    },
    colType: {
      width: 150
    },
    searchTextField: {
      margin: "5px"
    },
    switchDisabled: {
      "& .MuiSwitch-colorPrimary.Mui-disabled": {
        color: "#ffff"
      },
      "& .MuiSwitch-colorPrimary.Mui-disabled + .MuiSwitch-track": {
        backgroundColor: "#C8C8C8"
      }
    },
    table: {
      tableLayout: "fixed"
    },
    tableRow: {
      cursor: "pointer"
    },
    textField: {
      maginRight: "2px",
      width: "25ch"
    }
  }),
  { name: "DiscountProducts" }
);

const numberOfColumnsVoucher = 7;

const DiscountProducts: React.FC<SaleProductsProps> = props => {
  const {
    data,
    elligibleProducts,
    disabled,
    productPageInfo,
    voucherStatus,
    onFetch,
    onRowClick,
    onPreviousProductPage,
    onProductAssign,
    onProductUnassign,
    onNextProductPage,
    onChange,
    isChecked,
    selected,
    toggle,
    toggleAll,
    toolbar,
    voucher,
    voucherVariants
  } = props;

  React.useEffect(() => {
    if ((getQuantity() > 0 && !disabled) || elligibleProducts?.totalCount > 0) {
      onChange({
        target: {
          name: "isEligibleItems",
          value: true
        }
      });
    }
  }, [elligibleProducts]);

  const classes = useStyles(props);
  const intl = useIntl();
  const [query, onQueryChange] = useSearchQuery(onFetch);
  function getQuantity() {
    return maybe(() => elligibleProducts.totalCount, 0);
  }

  function showVariantsTable() {
    const variantsData = maybe(() => voucherVariants.map(edge => edge.node));

    return (
      <ResponsiveTable className={classes.table}>
        <colgroup>
          <col />
          <col className={classes.colName} />
          <col className={classes.colType} />
          <col className={classes.colPrice} />
          <col className={classes.colPrice} />
          <col className={classes.colPrice} />
          <col className={classes.colActions} />
        </colgroup>
        <TableHead
          colSpan={numberOfColumnsVoucher}
          selected={selected}
          disabled={disabled}
          items={variantsData}
          toggleAll={toggleAll}
          toolbar={toolbar}
        >
          <TableCell className={classes.colName}>
            <span className={classes.colNameLabel}>
              <FormattedMessage defaultMessage="Product Name" />
            </span>
          </TableCell>
          <TableCell className={classes.colType}>
            <FormattedMessage defaultMessage="Classification" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Retail Price" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="Tenant Discount" />
          </TableCell>
          <TableCell className={classes.colPrice}>
            <FormattedMessage defaultMessage="SMO Discount" />
          </TableCell>
          <TableCell className={classes.colActions} />
          {variantsData && variantsData.length === 0 && (
            <TableCell className={classes.colActions} />
          )}
        </TableHead>
        <TableFooter>
          <TableRow>
            <TablePagination
              colSpan={numberOfColumnsVoucher}
              hasNextPage={
                productPageInfo ? productPageInfo.hasNextPage : false
              }
              onNextPage={onNextProductPage}
              hasPreviousPage={
                productPageInfo ? productPageInfo.hasPreviousPage : false
              }
              onPreviousPage={onPreviousProductPage}
            />
          </TableRow>
        </TableFooter>
        <TableBody>
          {renderCollection(
            variantsData,
            (product, index) => {
              const isSelected = product ? isChecked(product.id) : false;
              return (
                <TableRow
                  hover={!!product}
                  key={product ? product.id : "skeleton"}
                  onClick={product && onRowClick(product.id)}
                  className={classes.tableRow}
                  selected={isSelected}
                >
                  <TableCell padding="checkbox">
                    <Checkbox
                      id={`productCheckboxRow${index}`}
                      checked={isSelected}
                      disabled={disabled}
                      disableClickPropagation
                      onChange={() => toggle(product.id)}
                    />
                  </TableCell>
                  <TableCell
                    className={classes.colName}
                    id={`productNameRow${index}`}
                  >
                    {maybe<React.ReactNode>(
                      () => `${product.product.name}, ${product.name}`,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell
                    className={classes.colType}
                    id={`productClassificationRow${index}`}
                  >
                    {maybe<React.ReactNode>(
                      () => product.product.productType.name,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell
                    className={classes.colPrice}
                    id={`productRetailPriceRow${index}`}
                  >
                    {maybe<React.ReactNode>(
                      () => product.price.amount,
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell
                    className={classes.colPrice}
                    id={`productTenantDiscountRow${index}`}
                  >
                    {maybe<React.ReactNode>(
                      () => parseFloat(`${product.tenantShare}`).toFixed(2),
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell
                    className={classes.colPrice}
                    id={`productSMODiscountRow${index}`}
                  >
                    {maybe<React.ReactNode>(
                      () => parseFloat(`${product.smoShare}`).toFixed(2),
                      <Skeleton />
                    )}
                  </TableCell>
                  <TableCell className={classes.colActions}>
                    <IconButton
                      id={`productDeleteBtnRow${index}`}
                      disabled={voucherStatus}
                      onClick={event => {
                        event.stopPropagation();
                        onProductUnassign(product.id);
                      }}
                    >
                      <DeleteIcon
                        color={voucherStatus ? "disabled" : "primary"}
                      />
                    </IconButton>
                  </TableCell>
                </TableRow>
              );
            },
            () => (
              <TableRow>
                <TableCell colSpan={numberOfColumnsVoucher}>
                  <FormattedMessage defaultMessage="No products found" />
                </TableCell>
              </TableRow>
            )
          )}
        </TableBody>
      </ResponsiveTable>
    );
  }

  return (
    <Card>
      <CardTitle
        title={
          <>
            <div className={classes.cardTitlebar}>
              <Switch
                className={
                  disabled || !data.isEligibleItems
                    ? classes.switchDisabled
                    : null
                }
                id="isEligibleItemToggle"
                disabled={voucherStatus || data.isEligibleStores}
                color="primary"
                checked={data.isEligibleItems}
                onChange={event =>
                  onChange({
                    target: {
                      name: "isEligibleItems",
                      value: event.target.checked
                    }
                  })
                }
                name="isEligibleItems"
              />
              {intl.formatMessage(
                {
                  defaultMessage: "Eligible Items ({quantity})",
                  description: "number of products"
                },
                {
                  quantity: getQuantity()
                }
              )}
              <div className={classes.searchTextField}></div>
            </div>
            {data.isEligibleItems ? (
              <div>
                <TextField
                  fullWidth
                  margin="dense"
                  placeholder="Search Products"
                  value={query}
                  onChange={onQueryChange}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchOutlined />
                      </InputAdornment>
                    )
                  }}
                />
              </div>
            ) : null}
          </>
        }
        toolbar={
          voucher &&
          (voucher.type === "E_VOUCHER" ||
            voucher.type === "SPECIFIC_PRODUCT") ? (
            <div className={data.isEligibleItems ? classes.buttonText : null}>
              <Button
                id="assignItemsBtn"
                disabled={disabled || !data.isEligibleItems}
                color="primary"
                className={
                  disabled || !data.isEligibleItems
                    ? classes.buttonDisabled
                    : null
                }
                onClick={onProductAssign}
              >
                <FormattedMessage
                  defaultMessage="Assign Items"
                  description="button"
                />
              </Button>
            </div>
          ) : (
            ""
          )
        }
      />
      {/* {isEvoucher || isPercentage ? showVariantsTable() : showVoucherTable()} */}
      {data.isEligibleItems ? showVariantsTable() : null}
    </Card>
  );
};
DiscountProducts.displayName = "DiscountProducts";
export default DiscountProducts;
